import { render } from "./Basics.vue?vue&type=template&id=7c681e14&scoped=true"
import script from "./Basics.vue?vue&type=script&lang=js"
export * from "./Basics.vue?vue&type=script&lang=js"

import "./Basics.vue?vue&type=style&index=0&id=7c681e14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c681e14"]])

export default __exports__